import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const RedditIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" {...props}>
    <path d="M14.238 15.348c.085.084.085.221 0 .306-.465.462-1.194.687-2.231.687l-.008-.002-.008.002c-1.036 0-1.766-.225-2.231-.688-.085-.084-.085-.221 0-.305.084-.084.222-.084.307 0 .379.377 1.008.561 1.924.561l.008.002.008-.002c.915 0 1.544-.184 1.924-.561.085-.084.223-.084.307 0zm-3.44-2.418c0-.507-.414-.919-.922-.919-.509 0-.923.412-.923.919 0 .506.414.918.923.918.508.001.922-.411.922-.918zm13.202-.93c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-5-.129c0-.851-.695-1.543-1.55-1.543-.417 0-.795.167-1.074.435-1.056-.695-2.485-1.137-4.066-1.194l.865-2.724 2.343.549-.003.034c0 .696.569 1.262 1.268 1.262.699 0 1.267-.566 1.267-1.262s-.568-1.262-1.267-1.262c-.537 0-.994.335-1.179.804l-2.525-.592c-.11-.027-.223.037-.257.145l-.965 3.038c-1.656.02-3.155.466-4.258 1.181-.277-.255-.644-.415-1.05-.415-.854.001-1.549.693-1.549 1.544 0 .566.311 1.056.768 1.325-.03.164-.05.331-.05.5 0 2.281 2.805 4.137 6.253 4.137s6.253-1.856 6.253-4.137c0-.16-.017-.317-.044-.472.486-.261.82-.766.82-1.353zm-4.872.141c-.509 0-.922.412-.922.919 0 .506.414.918.922.918s.922-.412.922-.918c0-.507-.413-.919-.922-.919z"/>
  </svg>
);

const PinterestIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" {...props}>
    <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-emerald-400">LOANYARD</span> CAPITAL
            </div>
            <p className="text-slate-400 mb-4 leading-relaxed">
              Corporate finance and capital advisory across debt, structured credit, asset-backed finance and strategic financing solutions.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/loanyard-capital/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin-link" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/loanyard.capital?igsh=MWh3ZzZ6bWhpdGlsbg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/share/1EKfQ6cB5m/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://x.com/loanyardcapital" target="_blank" rel="noopener noreferrer" aria-label="Twitter X" data-testid="footer-twitter-link" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.reddit.com/user/LOANYARDCAPITAL/" target="_blank" rel="noopener noreferrer" aria-label="Reddit" data-testid="footer-reddit-link" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <RedditIcon className="w-5 h-5" />
              </a>
              <a href="https://pin.it/4KpYrSSwJ" target="_blank" rel="noopener noreferrer" aria-label="Pinterest" data-testid="footer-pinterest-link" className="w-10 h-10 bg-slate-800 hover:bg-emerald-600 rounded-lg flex items-center justify-center transition-colors">
                <PinterestIcon className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-400 hover:text-emerald-400 transition-colors">Home</Link></li>
              <li><Link to="/calculators" className="text-slate-400 hover:text-emerald-400 transition-colors">Calculator</Link></li>
              <li><Link to="/insights" className="text-slate-400 hover:text-emerald-400 transition-colors">Insights</Link></li>
              <li><a href="/#contact" className="text-slate-400 hover:text-emerald-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Loan Products */}
          <div>
            <h3 className="text-lg font-bold mb-4">Capital Solutions</h3>
            <ul className="space-y-2">
              <li><Link to="/debt-syndication" className="text-slate-400 hover:text-emerald-400 transition-colors">Debt Syndication</Link></li>
              <li><Link to="/working-capital-finance" className="text-slate-400 hover:text-emerald-400 transition-colors">Working Capital Finance</Link></li>
              <li><Link to="/business-loans" className="text-slate-400 hover:text-emerald-400 transition-colors">Business Loans</Link></li>
              <li><Link to="/machinery-loan" className="text-slate-400 hover:text-emerald-400 transition-colors">Machinery Loan</Link></li>
              <li><Link to="/loan-against-property" className="text-slate-400 hover:text-emerald-400 transition-colors">Loan Against Property</Link></li>
              <li><Link to="/trade-finance-solutions" className="text-slate-400 hover:text-emerald-400 transition-colors">Trade Finance</Link></li>
              <li><Link to="/term-loan" className="text-slate-400 hover:text-emerald-400 transition-colors">Term Loan</Link></li>
              <li><Link to="/project-finance" className="text-slate-400 hover:text-emerald-400 transition-colors">Project Finance</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-slate-400">+91 98927 59155</p>
                  <p className="text-sm text-slate-500">Mon-Sat: 9 AM - 7 PM</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <p className="text-slate-400">support@loanyardcapital.com</p>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <p className="text-slate-400">C-20, Enam Sambhav, G Block BKC<br/>Bandra Kurla Complex, Mumbai 400051</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} LOANYARD CAPITAL. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/#about" className="text-slate-400 hover:text-emerald-400 transition-colors">About</a>
              <Link to="/insights" className="text-slate-400 hover:text-emerald-400 transition-colors">Capital Insights</Link>
              <Link to="/become-partner" className="text-slate-400 hover:text-emerald-400 transition-colors">Become Partner</Link>
            </div>
          </div>
          <div className="text-center mt-4 space-y-3">
            <p className="text-xs text-slate-500 max-w-3xl mx-auto">
              LOANYARD CAPITAL is a registered brand of MONEYYARD VENTURES PVT LTD. We provide corporate finance advisory and facilitate financing through banks, NBFCs and other financial institutions. Financing is subject to lender assessment, eligibility, documentation and applicable terms.
            </p>
            <p className="text-xs text-slate-600 leading-relaxed" data-testid="footer-legal-entity">
              <span className="font-semibold text-slate-500">LOANYARD CAPITAL</span><br />
              A registered brand of<br />
              <span className="font-semibold">MONEYYARD VENTURES PVT LTD</span><br />
              CIN: U70200MH2026PTC468985 | GSTIN: 27AAICI7372J1Z2<br />
              AMFI Registered Mutual Fund Distributor: ARN-370549
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
